const Role = Object.freeze({
  PATIENT: 'Patient',
  ADMIN: 'Admin',
  PROVIDER: 'Provider',
  PHLEBOTOMIST: 'Phlebotomist',
  STAFF: 'Staff',
})

export default Role